module.exports = __webpack_public_path__ + "static/img/arc-logo.c4452ec3.png";